import Grid from "@mui/material/Grid";
import { FixedHeightPaper } from "components/AlertsManagement/FixedHeightPaper";
import { AlertTableControls } from "components/AlertsManagement/AlertsTable/AlertsTableControls";
import useDumbPageTitle from "hooks/useDumbPageTitle";
import { useTrackPageView } from "hooks/useTrackPageView";
import { nth, size } from "lodash";
import { useContext, useEffect, useState } from "react";
import { usePagination } from "hooks/table-hooks/usePagination";
import { useGetArchivedAlerts } from "hooks/alerts/useGetArchivedAlerts";
import { AlertOccurenceInfo } from "components/AlertsManagement/Archived/AlertOccurrenceInfo";
import { getTimeFromDate } from "core/utils/getTimeFromDate";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "components/Breadcrumbs";
import { AlertFiltersContext } from "contexts/AlertFiltersContext";
import { ArchivedAlertsTable } from "components/AlertsManagement/Archived/ArchivedAlertsTable";

const PAGE_TITLE = "Archived";

export const ArchivedAlertsPage = () => {
  const [alertOccurrence, setAlertOccurrence] = useState();
  const [hasInitialAlert, setHasInitialAlert] = useState(false);
  const [sortByFields, setSortByFields] = useState([]);

  useDumbPageTitle(
    <Breadcrumbs>
      <Link to={`/pages/alerts`}>Alerts</Link>
      <div>{PAGE_TITLE}</div>
    </Breadcrumbs>
  );
  useTrackPageView(PAGE_TITLE);

  const {
    pageIndex,
    pageSize,
    changePageIndex,
    changePageSize
  } = usePagination();

  const { filters, setFilters } = useContext(AlertFiltersContext);

  const {
    severityFilter,
    siteFilter,
    machineFilter,
    startDateFilter,
    endDateFilter
  } = filters;

  const {
    loading: alertsLoading,
    error,
    alerts,
    count,
    refetchAlerts
  } = useGetArchivedAlerts(
    pageIndex + 1,
    pageSize,
    severityFilter.length !== 0 ? severityFilter : undefined,
    siteFilter?.id,
    machineFilter?.id,
    getTimeFromDate(startDateFilter),
    getTimeFromDate(endDateFilter),
    sortByFields
  );

  useEffect(() => {
    refetchAlerts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortByFields]);

  useEffect(() => {
    if (size(alerts) > 0 && !hasInitialAlert) {
      setAlertOccurrence(nth(alerts, 0));
      setHasInitialAlert(true);
    }
  }, [hasInitialAlert, alerts, pageIndex]);

  const handleSelectAlert = ({ original: activeAlert }) => {
    setAlertOccurrence(activeAlert);
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      <Grid item xs={12} sm={12} md={12} lg={7}>
        <FixedHeightPaper>
          <AlertTableControls
            filters={filters}
            onFilterChange={filterChange => {
              changePageIndex(0);
              setFilters(filterChange);
            }}
            startDateLabel="Actioned after"
            endDateLabel="Actioned before"
          />
          <ArchivedAlertsTable
            loading={alertsLoading}
            error={error}
            count={count}
            pageIndex={pageIndex}
            pageSize={pageSize}
            alertOccurrences={alerts ?? []}
            selectedAlert={alertOccurrence}
            onSelectAlert={handleSelectAlert}
            onChangeSortBy={sortBy => {
              changePageIndex(0);
              setSortByFields(sortBy);
            }}
            onPageChange={(_event, pageIndex) => changePageIndex(pageIndex)}
            onUpdatePageSize={changePageSize}
          />
        </FixedHeightPaper>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={5}>
        <FixedHeightPaper>
          <AlertOccurenceInfo
            alertOccurrence={alertOccurrence}
            alertsLoading={alertsLoading}
          />
        </FixedHeightPaper>
      </Grid>
    </Grid>
  );
};
